<template>
  <!-- 新建费用报销 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="70%"
    @cancel="handleCancel"
    :dialog-style="{ top: '4px' }"
  >
    <div v-if="maskDiv" class="maskDiv" @click="maskClick" />
    <div>
      <a-form-model
        ref="formRef"
        :model="form"
        labelAlign="right"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :rules="formRules"
      >
        <a-form-model-item label="报销类别">
          <a-radio-group
            v-model="reimbursementMethod"
            @change="reimbursementChange"
            :disabled="isDisabled"
          >
            <a-radio :value="0">项目报销</a-radio>
            <a-radio :value="1">销售机会报销</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="对应项目"
          prop="project"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
          v-if="reimbursementMethod === 0"
        >
          <a-input
            style="cursor: pointer;"
            read-only
            v-model="form.project"
            class="choosePerson"
            placeholder="点击选择项目"
            @click="openModal('project')"
          />
        </a-form-model-item>
        <a-form-model-item
          label="对应销售机会"
          prop="opportunityTitle"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
          v-if="reimbursementMethod === 1"
        >
          <a-input
            style="cursor: pointer;"
            read-only
            v-model="form.opportunityTitle"
            class="choosePerson"
            placeholder="点击选择销售机会"
            @click="openModal('salesOpportunities')"
          />
        </a-form-model-item>
        <a-form-model-item
          label="报销主题"
          prop="subject"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-input :disabled="isDisabled" v-model="form.subject" />
        </a-form-model-item>
        <a-form-model-item label="合同订单" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <a-select
            v-model="contractName"
            placeholder="请选择合同订单"
            style="width: 100%;"
            @dropdownVisibleChange="dropdownVisibleChanged"
            @change="changeContract"
          >
            <a-select-option
              v-for="(item,index) in contractList"
              :key="index"
              :value="item.id"
              :matterCode="item.id"
            >{{item.title}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="客户/供应商"
          prop="customerName"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-input
            :disabled="isDisabled"
            style="cursor: pointer;"
            read-only
            v-model="form.customerName"
            class="choosePerson"
            placeholder="点击选择客户/供应商"
            @click="openModal('customer')"
          />
          <!-- <p class="choosePerson" @click="openModal('customer')">{{ form.customerName || '点击选择客户/供应商'}}</p> -->
          <!-- <a-input :disabled="true" style="cursor: pointer;" read-only v-model="form.customerName" class="choosePerson" placeholder="客户/供应商"/> -->
        </a-form-model-item>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="申请日期" prop="reimbursementDate">
              <a-date-picker
                :disabled="isDisabled"
                @change="dateChange"
                v-model="form.reimbursementDate"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="申请人" prop="peopleName">
              <!-- <a-input v-model="form.people" /> -->
              <p
                class="choosePerson"
                @click="openPerson('people')"
              >{{ form.peopleName || '点击选择申请人' }}</p>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="报销金额" prop="amount">
              <a-input v-model="form.amount" :disabled="true" placeholder="报销金额根据报销明细自动计算得出" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="金额大写" prop="phone">
              <span>{{dealBigMoney(form.amount)}}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item
          label="报销明细"
          prop="reDetailsProp"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-icon type="info-circle" theme="filled" style="margin-right: 6px;" />
          <b>提示: 填写报销明细点击左侧'添加按钮', 填写金额后自动生成总报销金额</b>
          <br />
          <div class="myButtons">
            <a-button
              :disabled="isDisabled"
              icon="plus-circle"
              class="editable-add-btn"
              @click="addTableRow"
            >添加</a-button>
            <a-button
              :disabled="isDisabled"
              icon="plus-circle"
              class="editable-add-btn"
              @click="openModals"
            >批量添加</a-button>
            <!-- <a-tooltip placement="right" overlayClassName="“tooltip”">
              <template slot="title">
                <div>
                  <img src="/static/img/batchAddFlowchart.png" alt />
                </div>
              </template>
              <a-button
                :disabled="isDisabled"
                icon="plus-circle"
                class="editable-add-btn"
                @click="openModals"
              >批量添加</a-button>
            </a-tooltip>-->
            <!-- <a-button icon="check" type="primary" @click="saveRe">保存</a-button> -->
            <a-modal
              v-model="batchAddVisible"
              :dialog-style="{ top: '10px' }"
              width="60%"
              title="批量添加"
              ok-text="确认"
              cancel-text="取消"
              @cancel="batchAddVisible = false"
              @ok="hideModal"
            >
              <div class="batchAddBox">
                <div class="left">
                  <img src="/static/img/batchAddFlowchart.png" alt />
                </div>
                <div class="right">
                  <a-textarea
                    v-model="textareaValue"
                    placeholder="请将Excel表格数据复制到此处，点击确认即可批量添加"
                    :auto-size="{ minRows: 15, maxRows: 25 }"
                  />
                  <a-checkbox
                    style="margin-top: 30px"
                    @change="batchAddChange"
                  >覆盖原有报销明细，使用当前填写的数据作为报销明细</a-checkbox>
                </div>
              </div>
            </a-modal>
          </div>
          <a-table
            :data-source="reDetailsDataSouce"
            :columns="reDetailsColumns"
            :customRow="customRow"
            :rowClassName="rowClassName"
            :pagination="false"
            :rowKey="(record,index)=>{return index}"
            size="small"
            :scroll="{ x: 1000, y: 300 }"
            bordered
          >
            <template slot="status" slot-scope="text, record">
              <a-tooltip>
                <template
                  slot="title"
                >{{ record.status === 0 || record.status === null ? '' : '当前大额申请日期晚于费用报销日期！' }}</template>
                <a-icon
                  v-if="record.status !== 0 && record.status !== null"
                  type="exclamation-circle"
                  style="color: #f79c3a;"
                />
              </a-tooltip>
            </template>
            <template slot="costDate" slot-scope="text, record">
              <a-date-picker
                :disabled="isDisabled"
                v-model="record.costDate"
                :disabledDate="disableTodayAndAfter"
                @change=" (date, dateString) => constChange(date, dateString, record)"
              />
            </template>
            <template slot="costType" slot-scope="text, record">
              <a-select
                @change="e => typeChange(e,record)"
                v-model="record.costType"
                :disabled="isDisabled"
              >
                <a-select-option
                  v-for="(item,index) in costTypeList"
                  :key="index"
                  :value="item.label"
                >{{item.value}}</a-select-option>
              </a-select>
            </template>
            <template slot="amount" slot-scope="text, record">
              <a-input-number
                :disabled="isDisabled"
                :min="1"
                v-model="record.amount"
                @blur="countAmount"
                @change="e => amountChange(e, record)"
              />
            </template>
            <template slot="billNum" slot-scope="text, record">
              <a-input-number
                :disabled="isDisabled"
                :min="0"
                v-model="record.billNum"
                @change="e => numberChange(e, record)"
              />
            </template>
            <template slot="purpose" slot-scope="text, record">
              <a-input
                :disabled="isDisabled"
                v-model="record.purpose"
                @change="e => purposeChange(e.target.value, record)"
              />
            </template>
            <!-- 新增俩列 -->
            <template slot="largeAmountApply" slot-scope="text, record">
              <a-checkbox :checked="record.flag" :disabled="isDisabled" />
            </template>
            <template slot="bigamountId" slot-scope="text, record">
              <span
                v-if="record.flag"
                style="color:#1890ff; margin-right: 10px; cursor: pointer;"
                @click="LargeAmountSelect(record)"
              >{{record.bigamountId ? record.bigamountId : "选择"}}</span>
            </template>
            <!--  -->
            <template slot="operation" slot-scope="text, record">
              <!-- <a-popconfirm
                  v-if="reDetailsDataSouce.length && title === '[修改]费用报销'"
                  title="确定重置吗？"
                  @confirm="() => restTableRow(record,record.id, record.key)"
                >
                  <a href="javascript:;" style="color:orange;">重置</a>
              </a-popconfirm>-->
              <!-- <a-divider type="vertical"/> -->
              <a-popconfirm
                v-if="reDetailsDataSouce.length"
                title="确定删除吗？"
                @confirm="() => deleteTableRow(record,record.id, record.key)"
              >
                <a href="javascript:;" style="color:red;">删除</a>
              </a-popconfirm>
            </template>
          </a-table>
          <p>共{{reDetailsDataSouce.length}}条</p>
        </a-form-model-item>
        <a-form-model-item
          label="发票明细"
          prop="invoiceDetails"
          :labelCol="rowLabel"
          :wrapperCol="rowWrapper"
        >
          <a-icon type="info-circle" theme="filled" style="margin-right: 6px;" />
          <b>提示: 填写发票明细，请点击“添加发票”按钮上传电子发票，系统可自动识别发票信息。</b>
          <br />
          <div class="myButton">
            <a-upload
              name="file"
              :multiple="false"
              :action="action"
              :headers="headers"
              @change="uploadInvoice"
              :show-upload-list="false"
            >
              <a-button
                :disabled="isDisabled || invoiceLoadding"
                icon="plus-circle"
                class="editable-add-btn"
              >添加发票</a-button>
              <!-- <a-button :disabled="isDisabled" icon="plus-circle" class="editable-add-btn" @click="addInvoiceTableRow">添加</a-button> -->
            </a-upload>
            <!-- <a-button icon="check" type="primary" @click="saveRe">保存</a-button> -->
          </div>
          <a-table
            :data-source="invoiceDetailsDataSouce"
            :columns="invoiceDetailsColumns"
            :pagination="false"
            :loading="invoiceLoadding"
            :rowKey="(record,index)=>{return index}"
            size="small"
            bordered
          >
            <template slot="fileName" slot-scope="text, record">
              <a-tooltip placement="topLeft">
                <template slot="title">{{record.fileName}}</template>
                <a :href="baseURL + record.fileUrl" target="_blank">{{record.fileName}}</a>
              </a-tooltip>
            </template>
            <template slot="invoiceDate" slot-scope="text, record">
              <a-date-picker
                :disabled="isDisabled"
                :format="dateFormat"
                v-model="record.invoiceDate"
                @change=" (date, dateString) => invoiceDateChange(date, dateString, record)"
              />
            </template>
            <template slot="invoiceNumber" slot-scope="text, record">
              <a-input :disabled="isDisabled" v-model="record.invoiceNumber" />
            </template>
            <template slot="money" slot-scope="text, record">
              <a-input-number
                :disabled="isDisabled"
                :step="0.01"
                :min="0"
                :precision="2"
                v-model="record.money"
              />
            </template>
            <template slot="invoiceCode" slot-scope="text, record">
              <a-input :disabled="isDisabled" v-model="record.invoiceCode" />
            </template>
            <template slot="invoiceCheckCode" slot-scope="text, record">
              <a-input :disabled="isDisabled" v-model="record.invoiceCheckCode" />
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-row>
                <!-- <a-upload
                    name="file"
                    :multiple="true"
                    :action="action"
                    :headers="headers"
                    @change="uploadInvoice"
                    :show-upload-list="false"
                  >
                    <a v-if="invoiceDetailsDataSouce.length" href="javascript:;" style="color: #1890ff;">上传</a>
                </a-upload>-->
                <!-- <a-divider type="vertical"/> -->
                <a-popconfirm
                  v-if="invoiceDetailsDataSouce.length"
                  title="确定删除吗？"
                  @confirm="() => deleteInvoiceRow(record)"
                >
                  <a href="javascript:;" style="color:red;">删除</a>
                </a-popconfirm>
              </a-row>
            </template>
          </a-table>
          <p>已上传发票附件{{invoiceDetailsDataSouce.length}}</p>
        </a-form-model-item>
        <a-form-model-item label="备注" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <a-textarea
            v-model="form.remark"
            placeholder="请输入备注"
            allowClear
            :max-length="1000"
            :rows="4"
            showCount
            :autoSize="{ minRows: 4, maxRows: 20 }"
            :disabled="isDisabled"
          />
        </a-form-model-item>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="有票金额" prop="amountTickets">
              <!-- <a-input v-model="form.amountTickets" /> -->
              <a-input-number
                :disabled="isDisabled"
                v-model="form.amountTickets"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="无票金额" prop="amountNoTickets">
              <!-- <a-input v-model="form.amountNoTickets" /> -->
              <a-input-number
                :disabled="isDisabled"
                v-model="form.amountNoTickets"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="缺票金额" prop="amountLackTickets">
              <!-- <a-input v-model="form.amountLackTickets" /> -->
              <a-input-number
                :disabled="isDisabled"
                v-model="form.amountLackTickets"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="补票金额" prop="amountReplacementTicket">
              <!-- <a-input v-model="form.amountReplacementTicket" /> -->
              <a-input-number
                :disabled="isDisabled"
                v-model="form.amountReplacementTicket"
                :step="0.01"
                :min="0"
                :precision="2"
                style="width: 100%;"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="项目负责人" prop="dutyPerson">
              <!-- <a-input v-model="form.dutyPerson" /> -->
              <!-- <a-select placeholder="请选择项目负责人" v-model="form.dutyPerson" @change="dutyPersonChange" :disabled="isDisabled">
                  <a-select-option v-for="(item,index) in dutyPersonList" :key="index" :value="item.label" >
                    {{item.value}}
                  </a-select-option>
              </a-select>-->
              <a-input :disabled="true" v-model="form.dutyPerson" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="抄送人" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <!-- 选择树 -->
          <p
            class="choosePerson"
            @click="openPerson('person',form.userName, form.userId)"
          >{{ form.userName || '点击选择抄送人'}}</p>
        </a-form-model-item>
        <a-form-model-item label="上传附件" :labelCol="rowLabel" :wrapperCol="rowWrapper">
          <upload-attachment
            ref="uploadRef"
            :val-name="valName"
            :class="isDisabled ? 'isDisabled' : ''"
          />
        </a-form-model-item>
      </a-form-model>
      <!-- <customerDialog
          :dialogVisible="customerVisible"
          @logSuccess="customerSuccess"
          @cancel="customerCancel"
          :title="titles"
        />
        <projectDialog
          :dialogVisible="projectVisible"
          @logSuccess="projectSuccess"
          @cancel="projectCancel"
      />-->
      <personnel
        :visible="personVisible"
        :chooseData="personData"
        :isOnce="isOncePerson"
        @close="personClose"
        @success="personSuccess"
      />
    </div>
    <template slot="footer">
      <!-- <div id="footerDiv"> -->
      <!-- <check-flow-vue /> -->
      <div class="footer_right">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="handleOk(0)">保存</a-button>
        <a-button
          @click="handleOk(1)"
          :loading="loading"
          style="color:#fff;background-color:#52c41a;"
        >保存并提交审核</a-button>
      </div>
      <!-- </div> -->
    </template>
    <select-large-amount
      ref="selectRef"
      :title="addTitle"
      :dialog-visible="addVisible"
      :currentDecimalDetailList="currentDecimalDetailList"
      :beforeDecimalDetailList="beforeDecimalDetailList"
      :reimbursementMethod="reimbursementMethod"
      @success="addSuccess"
      @close="addClose"
    />
    <div>
      <publicDialog
        :title="publicDia.title"
        :dialog-visible="publicDia.visible"
        :component-name="publicDia.comName"
        :isReimSale="true"
        @logSuccess="publicDialogSucc"
        @cancel="handleClose"
      />
    </div>
  </a-modal>
</template>

<script>
import moment from 'moment'
import db from '@/utils/localstorage'
import { getNowFormatDate } from '@/utils/timer'
import { dealBigMoney } from '@/utils/common'
import personnel from '@/components/personnel'
// import customerDialog from '@/components/modelDialog/customerDialog'
// import projectDialog from '@/components/modelDialog/projectDialog'
import uploadAttachment from '../../common/Upload.vue'
import checkFlowVue from '../../common/checkFlow.vue'
import selectLargeAmount from './select'
import publicDialog from '@/components/modelDialog/publicDialog.vue'
import { getDefaultCarbonPerson } from '@/utils/index.js'
export default {
  name: 'AddEdit',
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    clientType: {
      type: Array,
      default: () => []
    },
    dutyPersonList: {
      type: Array,
      default: () => []
    }
  },
  provide () {
    return {
      formData: this,
      type: true
    }
  },
  components: { personnel, uploadAttachment, checkFlowVue, selectLargeAmount, publicDialog },
  data () {
    let checkMoney = (rule, value, callback) => {
      const reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      if (!reg.test(value)) {
        // eslint-disable-next-line standard/no-callback-literal
        return callback('请输入正确的金额，最多可保留两位小数！')
      }
      callback()
    }
    let checkTableData = (rule, value, callback) => {
      if (this.reDetailsDataSouce.length === 0) {
        // eslint-disable-next-line standard/no-callback-literal
        return callback('请填写报销明细')
      } else {
        this.reDetailsDataSouce.forEach(element => {
          // 必须填写日期、类别、金额
          if (element.costData === null || element.costData === '' || element.costType === null || element.costType === '' || element.amount === null || element.amount === '' || element.bigamountId === null || element.bigamountId === '') {
            // eslint-disable-next-line standard/no-callback-literal
            return callback('请填写报销明细')
          }
        })
      }
      callback()
    }
    // let checkInvoiceData = (rule, value, callback) => {
    //   if (this.invoiceDetailsDataSouce.length === 0) {
    //     // eslint-disable-next-line standard/no-callback-literal
    //     return callback('请填写发票明细')
    //   } else {
    //     this.invoiceDetailsDataSouce.forEach(element => {
    //       // 必须填写日期、类别、金额
    //       if (element.invoiceDate === null || element.invoiceDate === '' || element.invoiceCode === null || element.invoiceCode === '' || element.money === null || element.money === '' || element.invoiceNumber === null || element.invoiceNumber === '' || element.invoiceCheckCode === null || element.invoiceCheckCode === '') {
    //         // eslint-disable-next-line standard/no-callback-literal
    //         return callback('请填写发票明细')
    //       }
    //     })
    //   }
    //   callback()
    // }
    return {
      textareaValue: '',
      batchAddChecked: false,
      contractName: '',
      dateFormat: 'YYYY-MM-DD',
      publicDia: {
        title: '',
        visible: false,
        comName: ''
      },
      tableScroll: { x: 1000, y: 480 },
      addVisible: false,
      addTitle: '[选择]-大额申请',
      contractList: [], // 合同下拉框
      form: {
        reimbursementDate: moment(new Date(), 'YYYY-MM-DD'),
        peopleId: db.get('USER').userId,
        peopleName: db.get('USER').username
      },
      maskDiv: false,
      isProjectType: true,
      titles: '对应客户/供应商',
      uploadFileList: [],
      valName: 'uploadFileList',
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      loading: false,
      rowLabel: { span: 3 },
      rowWrapper: { span: 19 },
      formRules: {
        project: [
          { required: true, message: '请选择对应项目', trigger: 'blur' }
        ],
        opportunityTitle: [
          { required: true, message: '请选择对应销售机会', trigger: 'blur' }
        ],
        subject: [
          { required: true, message: '请输入报销主题', trigger: 'blur' }
        ],
        customerName: [
          { required: true, message: '请选择对应客户/供应商', trigger: 'blur' }
        ],
        reimbursementDate: [
          { required: true, message: '请选择申请日期', trigger: 'change' }
        ],
        // invoiceDetails: [
        //   { required: true, validator: checkInvoiceData, trigger: 'blur' }
        // ],
        peopleName: [
          { required: true, message: '请选择申请人', trigger: 'blur' }
        ],
        amount: [
          { required: true, message: '请输入报销金额', trigger: 'blur' }
        ],
        reDetailsProp: [
          { required: true, validator: checkTableData, trigger: 'blur' }
        ],
        amountTickets: [
          { required: true, message: '请填写有票金额', trigger: 'blur' },
          { validator: checkMoney, trigger: 'blur' }
        ],
        amountNoTickets: [
          { required: true, message: '请输入无票金额', trigger: 'blur' },
          { validator: checkMoney, trigger: 'blur' }
        ],
        amountLackTickets: [
          { required: true, message: '请输入缺票金额', trigger: 'blur' },
          { validator: checkMoney, trigger: 'blur' }
        ],
        amountReplacementTicket: [
          { required: true, message: '请输入补票金额', trigger: 'blur' },
          { validator: checkMoney, trigger: 'blur' }
        ],
        dutyPerson: [
          { required: true, message: '请选择项目负责人', trigger: 'blur' }
        ]
      },
      tableCount: 0,
      reDetailsDataSouce: [],
      reDetailsColumns: [
        {
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center',
          width: 30
        },
        {
          width: 150,
          title: '费用日期',
          dataIndex: 'costDate',
          scopedSlots: { customRender: 'costDate' },
          align: 'center'
        },
        {
          width: 150,
          title: '费用类别',
          dataIndex: 'costType',
          scopedSlots: { customRender: 'costType' },
          align: 'center'
        },
        {
          width: 120,
          title: '金额',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          align: 'center'
        },
        {
          width: 120,
          title: '票据张数',
          dataIndex: 'billNum',
          scopedSlots: { customRender: 'billNum' },
          align: 'center'
        },
        {
          width: 120,
          title: '用途',
          dataIndex: 'purpose',
          ellipsis: true,
          scopedSlots: { customRender: 'purpose' },
          align: 'center'
        }
      ],
      invoiceDetailsDataSouce: [],
      invoiceDetailsColumns: [
        {
          title: '发票名称',
          dataIndex: 'fileName',
          scopedSlots: { customRender: 'fileName' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '开票日期',
          dataIndex: 'invoiceDate',
          scopedSlots: { customRender: 'invoiceDate' },
          align: 'center'
        },
        {
          title: '发票代码',
          dataIndex: 'invoiceCode',
          scopedSlots: { customRender: 'invoiceCode' },
          align: 'center'
        },
        {
          title: '合计金额',
          dataIndex: 'money',
          scopedSlots: { customRender: 'money' },
          align: 'center'
        },
        {
          title: '发票号码',
          dataIndex: 'invoiceNumber',
          scopedSlots: { customRender: 'invoiceNumber' },
          align: 'center'
        },
        {
          title: '发票校验码',
          dataIndex: 'invoiceCheckCode',
          scopedSlots: { customRender: 'invoiceCheckCode' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          width: 130
        }
      ],
      costTypeList: [],
      costTypeObj: {},
      // 选择客户
      customerVisible: false,
      // 选择项目
      projectVisible: false,
      // 选择人员
      personVisible: false,
      personData: {},
      isOncePerson: false,
      // 审批人员
      approverData: [{
        name: ['王泽明', '刘涛成'],
        status: 2
      }, {
        name: ['江明', '刘微微'],
        status: 1
      }],
      // 金额限制
      amountLimit: 0,
      // 次数限制
      numLimit: 0,
      // 标记是那一条报销明细
      flagDetail: 0,
      // 报销明细--大额申请
      largeAmountData: [],
      // 当前报销明细数据
      currentDecimalDetailList: '',
      // 之前
      beforeDecimalDetailList: '',
      classRestriction: [], // 报销类别限制
      roleList: [],
      roleId: JSON.parse(localStorage.getItem('USER')).roleId.split(','),
      amountLimitAuth: false,
      reimbursementLimit: [],
      isDisabled: false, // 审核通过允许修改对应项目
      action: this.$baseURL + '/reimbursement/uploadInvoice',
      baseURL: this.$baseURL,
      headers: {
        Authentication: this.$store.state.account.token
      },
      invoiceLoadding: false,
      index: null,
      reimbursementMethod: 0,
      batchAddVisible: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  mounted () {
    this.getDictData()
  },
  methods: {
    getNowFormatDate,
    dealBigMoney,
    batchAddChange (e) {
      this.batchAddChecked = e.target.checked
    },
    hideModal () {
      if (this.textareaValue === '') {
        this.$message.warning('请输入数据')
        return
      }
      // console.log(this.batchAddChecked, 'batchAddChecked')
      this.batchAddVisible = false
      let data = this.parseExpenseData(this.textareaValue)
      // console.log(data, '==================')
      data.forEach(item => {
        if (this.amountLimitAuth) {
          if (item.amount >= this.amountLimit) {
            item.flag = true
            item.bigamountId = ''
            item.status = 0
          } else {
            item.flag = false
            item.bigamountId = ''
            item.status = 0
          }
        }
        this.reimbursementLimit.forEach(r => {
          if (r === item.costType) { // 交通费 -- 差旅费
            item.flag = false
            item.bigamountId = ''
            item.status = 0
          }
        })
      })
      if (this.batchAddChecked) {
        this.reDetailsDataSouce = data
      } else {
        this.reDetailsDataSouce = this.reDetailsDataSouce.concat(data)
      }
      this.countAmount()
      this.textareaValue = ''
      this.batchAddChecked = false
    },
    openModals () {
      if (!this.form.opportunityId && !this.form.projectId) {
        this.$message.warning('请先选择对应项目或对应销售机会')
        return
      }
      this.batchAddVisible = true
    },
    // 新增数据转换方法
    parseExpenseData (rawData) {
      return rawData.split('\n').filter(Boolean).map(line => {
        // 使用空字符串兜底，处理列缺失情况
        const [costDate = '', category = '', amount = '0', billNum = '0', purpose = ''] = line.split('\t')
        // 日期格式校验（示例：2024/03/16）
        // const isValidDate = moment(costDate, 'YYYY/M/D', true).isValid()
        // console.log(this.costTypeList, '==costTypeList')
        let costType = ''
        this.costTypeList.forEach(item => {
          if (item.value === category) {
            costType = item.label
          }
        })
        // 新增未来日期校验
        const now = moment().startOf('day')
        const inputDate = moment(costDate, 'YYYY/M/D', true)
        const isValidDate = inputDate.isValid() && !inputDate.isAfter(now) // 校验日期有效性且不超过今天
        return {
          key: 'BX' + this.tableCount++,
          costDate: isValidDate ? inputDate.format('YYYY-MM-DD') : now.format('YYYY-MM-DD'), // 未来日期自动修正为当天
          costType: costType,
          amount: Number(amount.replace(/[^0-9.]/g, '')) || 0, // 过滤非数字字符
          billNum: Math.abs(parseInt(billNum)) || 0, // 确保非负数 票据张数
          purpose: String(purpose).trim().slice(0, 100), // 限制长度防止溢出
          flag: false, // 记录当前行是否可以做大额申请选择
          bigamountId: '', // 大额申请对应单号
          status: 0, // 记录当前行是否异常
          largeAmountData: {}, // 记录选择的大额申请数据
          delFlag: 0
        }
      })
    },
    reimbursementChange (e) { // 报销类别切换
      this.$set(this.form, 'opportunityId', '')
      this.$set(this.form, 'opportunityTitle', '')
      this.$set(this.form, 'project', '')
      this.$set(this.form, 'projectId', '')
      // this.reDetailsDataSouce = []
      this.reDetailsDataSouce.forEach((item, index) => {
        item.bigamountId = ''
      })
    },
    getDefaultPerson () {
      getDefaultCarbonPerson(0).then((res) => {
        if (res) {
          this.$set(this.form, 'userId', res.userIdList)
          this.$set(this.form, 'userName', res.userNameList)
        }
      })
    },
    publicDialogSucc (data, typeVal) {
      // console.log('data =>', data, typeVal)
      if (typeVal === 'projectManage') {
        this.$set(this.form, 'opportunityId', '')
        this.$set(this.form, 'opportunityTitle', '')
        this.$set(this.form, 'project', data.subject)
        this.$set(this.form, 'projectId', data.id)
        this.$set(this.form, 'dutyPerson', data.dutyPersonName)
        this.$set(this.form, 'customerName', data.mainCustomer)
        this.$set(this.form, 'customerId', data.mainCustomerId)
        // if (data.customerType === 1) {
        //   this.$set(this.form, 'customerName', data.mainCustomer)
        //   this.$set(this.form, 'customerId', data.mainCustomerId)
        // } else {
        //   this.$set(this.form, 'customerName', '')
        //   this.$set(this.form, 'customerId', '')
        // }
        this.$forceUpdate()
        this.$refs.formRef && this.$refs.formRef.clearValidate('project')
        // 根据已选择的项目 查询合同订单
        this.getContractList()
      } else if (typeVal === 'customerManage') {
        this.$set(this.form, 'customerId', data.id)
        this.$set(this.form, 'customerName', data.companyName)
        this.$refs.formRef && this.$refs.formRef.clearValidate('customerName')
        // 根据客户查询合同订单
        // this.getOrderList()
      } else if (typeVal === 'salesOpportunities/projectOpportunities') {
        this.$set(this.form, 'project', '')
        this.$set(this.form, 'projectId', '')
        this.$set(this.form, 'opportunityId', data.id)
        this.$set(this.form, 'opportunityTitle', data.opportunityTitle)
        this.$set(this.form, 'customerName', data.customerName)
        this.$set(this.form, 'customerId', data.customerId)
        this.$set(this.form, 'dutyPerson', data.dutyPersonName)
        this.$set(this.form, 'dutyPersonId', data.dutyPersonId)
        this.$refs.formRef && this.$refs.formRef.clearValidate('opportunityTitle')
      }
      this.handleClose()
    },
    openModal (type) {
      if (type === 'project') {
        this.publicDia.visible = true
        this.publicDia.title = '选择对应项目'
        this.publicDia.comName = 'projectManage'
      } else if (type === 'customer') {
        this.publicDia.visible = true
        this.publicDia.title = '选择对应客户/供应商'
        this.publicDia.comName = 'customerManage'
      } else if (type === 'salesOpportunities') {
        this.publicDia.visible = true
        this.publicDia.title = '选择对应销售机会'
        this.publicDia.comName = 'salesOpportunities/projectOpportunities'
      }
    },
    rowClassName (record, index) {
      // 根据isSelected状态返回不同的类名
      if (this.index === index) {
        return 'selected-row'
      }
      return ''
    },
    customRow (record, index) {
      return {
        on: {
          click: () => {
            // console.log(`点击了第 ${index + 1} 行，数据为：`, record)
            // 在这里处理点击事件，如显示详情、编辑等
            // 切换isSelected状态
            this.index = index
          }
        }
      }
    },
    handleClose () {
      this.publicDia.visible = false
    },
    addEdited () {
      this.maskDiv = false
    },
    setSales (e) { // 销售机会快速新建费用报销
      this.reimbursementMethod = 1
      // console.log(e, '=========')
      this.$set(this.form, 'opportunityTitle', e.opportunityTitle)
      this.$set(this.form, 'opportunityId', e.id)
      this.$set(this.form, 'customerId', e.customerId)
      this.$set(this.form, 'customerName', e.customerName)
    },
    setForm (formValue) {
      this.$get('/reimbursement/getById', { id: formValue.id }).then(res => {
        if (res.data.status === 1) {
          let data = res.data.data
          this.$nextTick(() => {
            this.form = { ...data }
          })
          delete this.form.decimalDetailList
          this.reDetailsDataSouce = JSON.parse(JSON.stringify(data.decimalDetailList))
          this.invoiceDetailsDataSouce = JSON.parse(JSON.stringify(data.invoiceList))
          this.largeAmountData = data.decimalDetailList
          if (data.opportunityId) this.reimbursementMethod = 1
          if (this.amountLimitAuth) {
            this.largeAmountData.forEach(e => {
              if (e.amount >= this.amountLimit) {
                // e.flag = true
                this.$set(e, 'flag', true)
              } else {
                // e.flag = false
                this.$set(e, 'flag', false)
              }
            })
            this.reDetailsDataSouce.forEach(e => {
              if (e.amount >= this.amountLimit) {
                // e.flag = true
                this.$set(e, 'flag', true)
              } else {
                // e.flag = false
                this.$set(e, 'flag', false)
              }
            })
          }
          if (data.checkStatus !== '' && data.checkStatus !== null && data.checkStatus !== 2) {
            this.maskDiv = true
            this.$message.warning('请先撤回后，再点击修改')
          } else if (data.checkStatus === 2) {
            this.maskDiv = false
            this.isDisabled = true
          } else {
            this.maskDiv = false
          }
          // 根据客户id获取合同列表
          if (data.contractId) this.getOrderInfo(data.contractId, data.projectId)
          if (data.fileIds) {
            // string 转 数组  循环获取附件信息
            let fileList = data.fileIds.split(',')
            this.$nextTick(() => {
              this.$refs.uploadRef.getFile(fileList)
            })
          }
          // 差旅 -- 交通
          this.reDetailsDataSouce.forEach(item1 => {
            this.reimbursementLimit.forEach(item2 => {
              if (item1.costType === item2) {
                item1.flag = false
                item1.bigamountId = ''
              }
            })
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    dateChange (date, dateString) {
      this.form.reimbursementDate = moment(dateString, 'YYYY-MM-DD')
    },
    initDectData () {
      this.costTypeList = this.$store.state.account.dictData.costTypeList
      this.costTypeList.forEach(item => { // 交通费和差旅费不挂大额
        this.classRestriction.forEach(item1 => {
          if (item.value === item1) {
            this.reimbursementLimit.push(item.label)
          }
        })
        // if (item.value === '交通费') {
        //   this.reimbursementLimit.push(item.label)
        // }
        // if (item.value === '差旅费') {
        //   this.reimbursementLimit.push(item.label)
        // }
        // if (item.value === '私车公用') {
        //   this.reimbursementLimit.push(item.label)
        // }
      })
    },
    constChange (val, dateString, rowData) { // 报销明细 - 费用日期
      rowData.costDate = dateString
      rowData.bigamountId = ''
    },
    typeChange (val, rowData) { // 报销类别
      rowData.costType = val
      rowData.bigamountId = ''
      if (this.amountLimitAuth) {
        if (rowData.amount >= this.amountLimit) {
          rowData.flag = true
          // rowData.bigamountId = ''
        } else {
          rowData.flag = false
          // rowData.bigamountId = ''
        }
      }
      this.reimbursementLimit.forEach(item => {
        if (item === rowData.costType) { // 交通费 -- 差旅费
          rowData.flag = false
          // rowData.bigamountId = ''
        }
      })
    },
    amountChange (val, rowData) { // 金额
      rowData.amount = val
      if (this.amountLimitAuth) {
        if (val >= this.amountLimit) {
          rowData.flag = true
          rowData.bigamountId = ''
          rowData.status = 0
        } else {
          rowData.flag = false
          rowData.bigamountId = ''
          rowData.status = 0
        }
      }
      this.reimbursementLimit.forEach(item => {
        if (item === rowData.costType) { // 交通费 -- 差旅费
          rowData.flag = false
          rowData.bigamountId = ''
          rowData.status = 0
        }
      })
    },
    numberChange (val, rowData) { // 票据张数
      rowData.billNum = val
    },
    purposeChange (val, rowData) { // 用途
      rowData.purpose = val
    },
    addTableRow () { // 添加报销明细行
      // console.log(!this.form.opportunityId && !this.form.projectId)
      if (!this.form.opportunityId && !this.form.projectId) {
        this.$message.warning('请先选择对应项目或对应销售机会')
        return
      }
      let count = this.tableCount
      this.tableCount++
      // console.log(count, 'count')
      let newData = {}
      if (this.reDetailsDataSouce.length) {
        let index = this.reDetailsDataSouce.length - 1
        newData = {
          key: 'BX' + count,
          costDate: this.reDetailsDataSouce[index].costDate,
          costType: this.reDetailsDataSouce[index].costType,
          amount: this.reDetailsDataSouce[index].amount,
          billNum: this.reDetailsDataSouce[index].billNum,
          purpose: this.reDetailsDataSouce[index].purpose,
          flag: this.reDetailsDataSouce[index].flag, // 记录当前行是否可以做大额申请选择
          bigamountId: '', // 大额申请对应单号
          status: 0, // 记录当前行是否异常
          largeAmountData: {}, // 记录选择的大额申请数据
          delFlag: 0
        }
      } else {
        newData = {
          key: 'BX' + count,
          costDate: '',
          costType: '',
          amount: '',
          billNum: 0,
          purpose: '',
          flag: false, // 记录当前行是否可以做大额申请选择
          bigamountId: '', // 大额申请对应单号
          status: 0, // 记录当前行是否异常
          largeAmountData: {}, // 记录选择的大额申请数据
          delFlag: 0
        }
      }
      this.reimbursementLimit.forEach(item => {
        if (item === newData.costType) { // 交通费 -- 差旅费
          newData.flag = false
          newData.bigamountId = ''
        }
      })
      this.reDetailsDataSouce.push(newData)
      // console.log(this.reDetailsDataSouce, 'reDetailsDataSouce')
      this.countAmount()
    },
    // 识别电子发票
    addInvoiceTableRow () {
      // this.invoiceDetailsDataSouce.push({
      //   invoiceCode: '',
      //   invoiceNumber: '',
      //   money: '',
      //   invoiceDate: '',
      //   invoiceCheckCode: ''
      // })
    },
    invoiceDateChange (date, dateString, rowData) {
      rowData.invoiceDate = dateString
    },
    deleteInvoiceRow (rowVal) {
      if (this.isDisabled) return
      const dataSource = [...this.invoiceDetailsDataSouce]
      if (rowVal.invoiceCode || rowVal.invoiceNumber) {
        this.invoiceDetailsDataSouce = dataSource.filter(item => item.invoiceCode + item.invoiceNumber !== rowVal.invoiceCode + rowVal.invoiceNumber)
      } else {
        this.invoiceDetailsDataSouce = dataSource.filter(item => item.invoiceFileId !== rowVal.invoiceFileId)
      }
    },
    uploadInvoice (info) {
      this.invoiceLoadding = true
      if (info.file.status === 'done') {
        // console.log(info.file.response.data.fileId, 'info.fileList[0].response.data.fileId')
        if (info.file.response.status) {
          this.$get('/reimbursement/invoiceRecognition', { fileId: info.file.response.data.fileId }).then(res => {
            if (res.data.status === 1) {
              let resData = res.data.data
              const dataSource = [...this.invoiceDetailsDataSouce]
              let length = dataSource.filter(item => item.invoiceCode + item.invoiceNumber === resData.invoiceCode + resData.invoiceNumber)
              if (length.length) {
                this.$message.warning('此发票重复上传，请重新添加')
              } else {
                this.invoiceDetailsDataSouce.push(resData)
              }
              this.invoiceLoadding = false
            } else if (res.data.status === 0) {
              this.$message.warning(res.data.message)
              this.invoiceLoadding = false
              this.invoiceDetailsDataSouce.push(res.data.data)
              // this.invoiceDetailsDataSouce.push({
              //   invoiceCode: '',
              //   invoiceNumber: '',
              //   money: '',
              //   invoiceDate: '',
              //   invoiceCheckCode: '',
              //   invoiceFileId: info.file.response.data.fileId
              // })
            } else {
              this.$message.warning(res.data.message)
              this.invoiceLoadding = false
            }
          })
        } else {
          this.$message.error(info.file.response.message)
        }
      }
    },
    countAmount () { // 金额输入框丢失焦点事件，计算总金额
      let sumMoney = 0
      this.reDetailsDataSouce.forEach(item => {
        sumMoney = Number(sumMoney) + Number(item.amount)
      })
      this.$set(this.form, 'amount', sumMoney.toFixed(2))
      // console.log('==>总金额', sumMoney, this.form.amount)
    },
    deleteTableRow (rowVal, idVal, keyVal) { // 删除报销明细行
      if (this.isDisabled) return
      const dataSource = [...this.reDetailsDataSouce]
      const largeAmountDataSource = [...this.largeAmountData]
      let key = ''
      // 判断是 新增明细(有key) 还是 已保存的明细(有id)
      if (idVal) {
        key = idVal
        this.reDetailsDataSouce = dataSource.filter(item => item.id !== key)
        this.largeAmountData = largeAmountDataSource.filter(item => item.id !== key)
      } else if (keyVal) {
        key = keyVal
        this.reDetailsDataSouce = dataSource.filter(item => item.key !== key)
        this.largeAmountData = largeAmountDataSource.filter(item => item.key !== key)
      }
      // 删除后重新计算总金额
      this.form.amount = Number(this.form.amount) - Number(rowVal.amount) || 0
    },
    dutyPersonChange (value) { // 负责人
      this.form.dutyPerson = value
    },
    containsDuplicate (nums) {
      for (let k = 1; k < nums.length; k++) {
        if (nums[k].invoiceCode + nums[k].invoiceNumber === nums[k - 1].invoiceCode + nums[k - 1].invoiceNumber) return true
      }
      return false
    },
    handleOk (val) {
      // console.log(this.reDetailsDataSouce, 'reDetailsDataSouce')
      const dataSource = [...this.invoiceDetailsDataSouce]
      const isKeep = this.containsDuplicate(dataSource)
      if (isKeep) {
        this.$message.warning('发票代码/发票号码重复，请重新添加')
        return
      }
      if (val === 1) {
        this.form.checkFlag = val
      } else {
        this.form.checkFlag = null
      }
      this.$refs.formRef.validate((valid) => {
        if (this.$refs.uploadRef.setCount !== 0) {
          this.form.fileIds = this.uploadFileList
        }
        if (valid) {
          this.loading = true
          // 剔除差旅费和交通费的大额id
          this.reDetailsDataSouce.forEach(item1 => {
            if (item1.largeAmountData) delete item1.largeAmountData
            this.reimbursementLimit.forEach(item2 => {
              if (item1.costType === item2) {
                delete item1.bigamountId
              }
            })
          })
          // 将moment类型转为string类型用于数据传输
          this.form.reimbursementDate = moment(this.form.reimbursementDate).format('YYYY-MM-DD')
          if (this.reDetailsDataSouce) this.form.decimalDetailList = JSON.stringify(this.reDetailsDataSouce)
          this.invoiceDetailsDataSouce.forEach(res => {
            if (res.invoiceCode === '') res.invoiceCode = null
            if (res.invoiceNumber === '') res.invoiceNumber = null
          })
          if (this.invoiceDetailsDataSouce) this.form.invoiceList = JSON.stringify(this.invoiceDetailsDataSouce) // 发票
          if (this.form.checkStatus === 2) {
            this.form.checkFlag = 0
          }
          if (this.title === `[新建]${this.$tree([], 'financialManage/expenseReim/index')}`) {
            this.$post('/reimbursement/add', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          } else {
            this.$post('/reimbursement/update', this.form).then(res => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message)
                this.$emit('success')
                this.resetForm()
              } else {
                this.$message.warning(res.data.message)
              }
            }).finally(r => {
              setTimeout(() => {
                this.loading = false
              }, 200)
            })
          }
        } else {
          this.$message.warning('表单存在必填项未填写，请填写后提交')
        }
      })
    },
    resetForm () {
      this.uploadFileList = []
      this.contractList = []
      this.reDetailsDataSouce = []
      this.invoiceDetailsDataSouce = []
      this.largeAmountData = []
      this.contractName = ''
      this.maskDiv = false
      this.isDisabled = false
      this.reimbursementMethod = 0
      this.tableCount = 0
      setTimeout(() => {
        this.form = {
          reimbursementDate: moment(new Date(), 'YYYY-MM-DD'),
          peopleId: db.get('USER').userId,
          peopleName: db.get('USER').username
        }
      }, 500)
    },
    handleCancel () {
      this.resetForm()
      this.$emit('close')
    },
    maskClick () {
      this.resetForm()
      this.$emit('close')
    },
    // openModal (type) {
    //   if (type === 'customer') {
    //     this.customerVisible = true
    //   } else if (type === 'project') {
    //     this.projectVisible = true
    //   }
    // },
    // 选择项目
    // projectSuccess (data) {
    //   this.$set(this.form, 'project', data.subject)
    //   this.$set(this.form, 'projectId', data.id)
    //   this.projectVisible = false
    //   this.$forceUpdate()
    //   this.$refs.formRef.clearValidate('project')
    // },
    // // 取消选择项目
    // projectCancel () {
    //   this.projectVisible = false
    // },
    // 选择客户
    // customerSuccess (data) {
    //   this.$set(this.form, 'customerId', data.id)
    //   this.$set(this.form, 'customerName', data.companyName)
    //   this.customerVisible = false
    //   this.$refs.formRef.clearValidate('customerName')
    //   // 根据客户查询合同订单
    //   this.getOrderList()
    // },
    // // 取消选择客户
    // customerCancel () {
    //   this.customerVisible = false
    // },
    getOrderList () {
      this.contractList = []
      this.$get('/contract/getByCustomerId', { customerId: this.form.customerId }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data.rows
          resData.forEach(item => {
            this.contractList.push({
              id: item.id,
              title: `${item.contractTitle}
              （
                单号：${item.contractCode}，
                创建人：${item.owner}，
                状态：${item.contractState === 0 ? '执行中' : item.contractState === 1 ? '结束' : '意外终止'}
              ）`
            })
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    // 根据选择 项目 筛选合同订单
    getContractList () {
      let params = {}
      if (this.form.projectId) {
        params.projectId = this.form.projectId
      }
      this.contractList = []
      this.contractName = ''
      // this.$set(this.form, 'customerId', '')
      // this.$set(this.form, 'customerName', '')
      this.$get('/contract/getByProjectId', params).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data.rows
          resData.forEach(item => {
            this.contractList.push({
              id: item.id,
              title: `${item.contractTitle}
              （
                单号：${item.contractCode}，
                创建人：${item.owner}，
                状态：${item.contractState === 0 ? '执行中' : item.contractState === 1 ? '结束' : '意外终止'}
              ）`
            })
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    // 查询合同
    getOrderInfo (id, pId) {
      this.$get('/contract/getByProjectId', { projectId: pId }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data.rows
          resData.forEach(item => {
            this.contractList.push({
              id: item.id,
              title: `${item.contractTitle}
              （
                单号：${item.contractCode}，
                创建人：${item.owner}，
                状态：${item.contractState === 0 ? '执行中' : item.contractState === 1 ? '结束' : '意外终止'}
              ）`
            })
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
      this.$get('/contract/getById', { id: id }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data
          this.contractName = `${resData.contractTitle}
              （
                单号：${resData.contractCode}，
                创建人：${resData.owner}，
                状态：${resData.contractState === 0 ? '执行中' : resData.contractState === 1 ? '结束' : '意外终止'}
              ）`
        } else {
          console.warn(`合同订单id为${id}=>${res.data.message}`)
        }
      })
    },
    dropdownVisibleChanged () {
      if (!this.form.projectId || this.form.projectId === '') {
        this.$message.warning('请先选择项目')
      }
    },
    // 选择合同
    changeContract (e) {
      this.$set(this.form, 'contractId', e)
      // this.getCustomerInfo(e)
    },
    // getCustomerInfo (id) { // 根据合同查客户
    //   this.$get('/contract/getById', {id: id}).then(res => {
    //     if (res.data.status === 1) {
    //       let resData = res.data.data
    //       this.$set(this.form, 'customerId', resData.customerId)
    //       this.$set(this.form, 'customerName', resData.customerName)
    //     } else {
    //       this.$message.warning(res.data.message)
    //     }
    //   })
    // },
    // 确认选择人员数据
    openPerson (val, name, id) { // 抄送人
      if (this.isDisabled) return
      if (val === 'person') {
        this.isOncePerson = false
        this.personData = { userId: id, userName: name }
        this.personVisible = true
      } else if (val === 'people') { // 申请人
        this.isOncePerson = true // 单选
        this.personVisible = true
      }
    },
    // 选择人员
    personSuccess (data, type) {
      if (type === 'checkType') {
        var username
        var userId
        data.forEach(item => {
          if (username) {
            username += ',' + item.username
          } else {
            username = item.username
          }
          if (userId) {
            userId += ',' + item.userId
          } else {
            userId = item.userId
          }
        })
        this.form.userName = username
        this.form.userId = userId
      } else { // 单选-申请人
        this.form.peopleId = data.userId
        this.form.peopleName = data.username
      }
      this.personVisible = false
    },
    // 取消选择人员
    personClose () {
      this.personVisible = false
    },
    // 去重
    Deduplication (arr) {
      for (var i = 0; i < arr.length; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].bigamountId === arr[j].bigamountId) {
            arr.splice(j, 1) // 第一个等同于第二个，splice方法删除第二个
            j--
          }
        }
      }
      return arr
    },
    // 大额申请相关
    LargeAmountSelect (e) {
      if (this.isDisabled) return
      // console.log(e, 'LargeAmountSelect', this.reDetailsDataSouce)
      let params = []
      let data = []
      this.reDetailsDataSouce.forEach(item => {
        if (item.bigamountId !== e.bigamountId) {
          params.push(item.bigamountId)
        }
      })
      this.currentDecimalDetailList = JSON.stringify(e)
      if (e.costDate === '' || e.costDate === null) {
        this.$message.warning('请先选择费用日期')
      } else {
        if (this.title === `[新建]${this.$tree([], 'financialManage/expenseReim/index')}`) {
          let before = this.reDetailsDataSouce.filter(item => item.bigamountId !== e.bigamountId)
          before = before.filter(item => item.bigamountId !== '')
          before = this.Deduplication(before)
          this.beforeDecimalDetailList = JSON.stringify(before)
          data = {
            beforeDecimalDetailList: this.beforeDecimalDetailList,
            currentDecimalDetailList: this.currentDecimalDetailList,
            peopleId: this.form.peopleId
          }
          this.$refs.selectRef.initData(data, params)
        } else {
          let before = this.reDetailsDataSouce.filter(item => item.bigamountId !== e.bigamountId)
          before = before.filter(item => item.bigamountId !== '')
          before = this.Deduplication(before)
          this.beforeDecimalDetailList = JSON.stringify(before)
          data = {
            beforeDecimalDetailList: this.beforeDecimalDetailList,
            currentDecimalDetailList: this.currentDecimalDetailList,
            peopleId: this.form.peopleId,
            reimbursementId: this.form.id
          }
          this.$refs.selectRef.initData(data, params)
        }
        // console.log(e, 'LargeAmountSelect', this.title)
        if (this.title === `[新建]${this.$tree([], 'financialManage/expenseReim/index')}`) {
          this.flagDetail = e.key
        } else {
          this.flagDetail = e.id || e.key
        }
        this.addVisible = true
      }
    },
    addSuccess (e) {
      const data = {}
      if (this.title === `[新建]${this.$tree([], 'financialManage/expenseReim/index')}`) {
        try {
          this.reDetailsDataSouce.forEach((element) => { // 设置对应单号
            if (element.key === this.flagDetail) {
              if (element.costDate >= e.applyDate) { // 正常
                element.status = 0
                if (element.bigamountId === '') {
                  this.largeAmountData.push({
                    key: element.key,
                    costDate: e.costDate,
                    status: 0,
                    bigamountId: e.id,
                    largeAmountDate: e.applyDate
                  })
                } else {
                  this.largeAmountData.forEach(item => {
                    if (item.key === element.key) {
                      item.status = 0
                      item.bigamountId = e.id
                    }
                  })
                }
              } else { // 异常
                element.status = 1
                if (element.bigamountId === '') {
                  this.largeAmountData.push({
                    key: element.key,
                    costDate: e.costDate,
                    status: 1,
                    bigamountId: e.id,
                    largeAmountDate: e.applyDate
                  })
                } else {
                  this.largeAmountData.forEach(item => {
                    if (item.key === element.key) {
                      item.status = 1
                      item.bigamountId = e.id
                    }
                  })
                }
              }
              element.bigamountId = e.id
              element.largeAmountData = e
              throw data
            }
          })
        } catch (e) {
          // console.log(e)
        }
      } else {
        try {
          this.reDetailsDataSouce.forEach((element) => { // 设置对应单号
            if (element.id === this.flagDetail || element.key === this.flagDetail) {
              if (element.costDate >= e.applyDate) { // 正常
                element.status = 0
                if (element.bigamountId === '') {
                  this.largeAmountData.push({
                    id: element.id,
                    costDate: e.costDate,
                    status: 0,
                    bigamountId: e.id,
                    largeAmountDate: e.applyDate
                  })
                } else {
                  this.largeAmountData.forEach(item => {
                    if (item.id === element.id) {
                      item.status = 0
                      item.bigamountId = e.id
                    }
                  })
                }
              } else { // 异常
                element.status = 1
                if (element.bigamountId === '') {
                  this.largeAmountData.push({
                    id: element.id,
                    costDate: e.costDate,
                    status: 1,
                    bigamountId: e.id,
                    largeAmountDate: e.applyDate
                  })
                } else {
                  this.largeAmountData.forEach(item => {
                    if (item.id === element.id) {
                      item.status = 1
                      item.bigamountId = e.id
                    }
                  })
                }
              }
              element.bigamountId = e.id
              element.largeAmountData = e
              throw data
            }
          })
        } catch (e) {
          // console.log(e)
        }
      }
      this.addVisible = false
    },
    addClose () {
      this.addVisible = false
    },
    // 获取字典值
    getDictData () {
      this.$get('/common/dict/getListByEn', { dictTypeEn: 'largeAmountApplication' }).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data
          resData.forEach((e) => {
            if (e.dictName === '大额申请金额限制') {
              this.amountLimit = e.dictTypeChs
            } else if (e.dictName === '大额申请次数限制') {
              this.numLimit = e.dictTypeChs
              this.$post('/bigAmount/violationCount', { peopleId: db.get('USER').userId }).then(res => {
                if (res.data.status === 1) {
                  const num = res.data.data
                  this.numLimit = this.numLimit - num
                } else {
                  this.$message.warning(res.data.msg)
                }
              })
            } else if (e.dictName === '金额-角色校验') {
              this.roleList = e.dictTypeChs.split(',')
              this.roleList.forEach(item => {
                this.roleId.forEach(roleItem => {
                  if (item === roleItem) {
                    this.amountLimitAuth = true
                  }
                })
              })
              let columnsAuth1 = [
                {
                  title: '大额申请',
                  dataIndex: 'largeAmountApply',
                  scopedSlots: { customRender: 'largeAmountApply' },
                  align: 'center',
                  width: 100
                },
                {
                  title: '对应单号',
                  dataIndex: 'bigamountId',
                  scopedSlots: { customRender: 'bigamountId' },
                  align: 'center'
                },
                {
                  title: '操作',
                  dataIndex: 'operation',
                  scopedSlots: { customRender: 'operation' },
                  align: 'center'
                }
              ]
              let columnsAuth2 = [
                {
                  title: '操作',
                  dataIndex: 'operation',
                  scopedSlots: { customRender: 'operation' },
                  align: 'center'
                }
              ]
              let checkTableDatas = (rule, value, callback) => {
                if (this.reDetailsDataSouce.length === 0) {
                  // eslint-disable-next-line standard/no-callback-literal
                  return callback('请填写报销明细')
                } else {
                  this.reDetailsDataSouce.forEach(element => {
                    // 必须填写日期、类别、金额
                    if (element.costData === null || element.costData === '' || element.costType === null || element.costType === '' || element.amount === null || element.amount === '') {
                      // eslint-disable-next-line standard/no-callback-literal
                      return callback('请填写报销明细')
                    }
                  })
                }
                callback()
              }
              let checkTableData = (rule, value, callback) => {
                if (this.reDetailsDataSouce.length === 0) {
                  // eslint-disable-next-line standard/no-callback-literal
                  return callback('请填写报销明细')
                } else {
                  this.reDetailsDataSouce.forEach(element => {
                    // 必须填写日期、类别、金额
                    if (element.costData === null || element.costData === '' || element.costType === null || element.costType === '' || element.amount === null || element.amount === '') {
                      // eslint-disable-next-line standard/no-callback-literal
                      return callback('请填写报销明细')
                    }
                    if (isBoolean(element)) {
                      const err = '请选择报销明细对应单号'
                      return callback(err)
                    }
                  })
                }
                callback()
              }
              // 当金额大于限制金额且不需要挂大额时，则单号不能为空
              let isBoolean = item => {
                let flag = false
                if (item.amount >= this.amountLimit) {
                  flag = this.reimbursementLimit.some((e) => e === item.costType)
                  if (flag) {
                    return false
                  } else {
                    if (!item.bigamountId) {
                      return true
                    } else {
                      return false
                    }
                  }
                }
              }
              if (this.amountLimitAuth) {
                this.reDetailsColumns = [...this.reDetailsColumns, ...columnsAuth1]
                this.formRules.reDetailsProp = [{ required: true, validator: checkTableData, trigger: 'blur' }]
              } else {
                this.reDetailsColumns = [...this.reDetailsColumns, ...columnsAuth2]
                this.formRules.reDetailsProp = [{ required: true, validator: checkTableDatas, trigger: 'blur' }]
              }
            }
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
      this.$get('/common/dict/getListByEn', { dictTypeEn: 'classRestriction' }).then(res => {
        const resData = res.data.data
        if (res.data.status) {
          this.classRestriction = []
          resData.forEach((e) => {
            this.classRestriction.push(e.dictName)
          })
          this.initDectData()
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    disableTodayAndAfter (current) {
      // const today = new Date() // 获取当前时间
      // return current && current > today // 如果选择的日期大于今天则返回true，否则返回false
      // 禁用今天之后的日期
      return current && current.endOf('day') > moment().endOf('day')
      // 获取当前时间（包含时区处理）
      // const now = moment().local()
      // // 克隆选择日期避免污染原始数据
      // const selected = current ? current.clone().local() : null

      // return selected && (
      //   // 禁用条件1：选择的年份大于当前年份
      //   selected.year() > now.year() ||
      //   // 禁用条件2：同年且选择的月份大于当前月份
      //   (selected.year() === now.year() && selected.month() > now.month()) ||
      //   // 禁用条件3：本月且选择的日期在今日之后
      //   (selected.isSame(now, 'month') && selected.date() > now.date())
      // )
    }
  }
}
</script>

<style lang="less" scope>
.maskDiv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.2);
}
.myButtons {
  display: flex;
  /* justify-content: space-between; */
  gap: 10px;
  margin-bottom: 6px;
}
/* 模态框中间内容 */
.ant-modal-body {
  max-height: calc(100vh - 130px);
  overflow-y: auto;
  padding: 10px 24px;
}
/* 模态框底部 */
.ant-modal-footer {
  height: 50;
  line-height: 50px;
}
/* #footerDiv{
    display: flex;
    justify-content: space-between;
  } */
/* #footerDiv{
    position: relative;
    right: 0;
  }
  #footerDiv .footer_left{
    display: flex;
  } */
.footer_left_content {
  display: flex;
}
.left_1 {
  margin: 0 10px;
  border: 1px dashed #ccc;
  margin-left: 10px;
  padding: 10px;
}
.isDisabled {
  pointer-events: none;
}
.selected-row {
  background-color: #e6f7ff;
}
.tooltip {
  background-color: #e6f7ff !important;
}
.batchAddBox {
  display: flex;
  justify-content: space-between;
  // .left {
  // }
  .right {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/financialManage/expenseReim/addEdit.vue